import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PathToConfidence() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const {
    ref: imgRef,
    isVisible: imgVisible
  } = useRevealOnScroll();
  return <section data-section-id="9096" id="experts-one-connection" className="relative w-full min-h-[90vh] flex items-center bg-background overflow-hidden py-20 lg:py-0 dark bg-background text-foreground">
      <div className="container mx-auto px-6 md:px-12 h-full">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 h-full items-center">
          {}
          <div ref={textRef} className={`lg:col-span-7 relative z-10 flex flex-col justify-center transition-all duration-1000 ease-out ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            {}
            <div className="absolute -top-32 -left-20 md:-left-32 text-[15rem] md:text-[25rem] leading-none font-sans font-bold text-primary/5 select-none -z-10 pointer-events-none">
              L
            </div>

            <h1 className="text-5xl md:text-7xl lg:text-8xl font-sans font-bold text-foreground leading-[1.1] tracking-tighter mb-10">
              Experts, <br />
              <span className="italic font-serif bg-gradient-to-r from-primary via-amber-400 to-primary bg-clip-text text-transparent">
                One Connection
              </span>
            </h1>

            <div className="flex flex-col sm:flex-row gap-6">
              <Button asChild className="h-16 px-10 text-lg rounded-full bg-primary text-primary-foreground hover:bg-primary/90 hover:scale-105 transition-all duration-500 shadow-xl hover:shadow-2xl group">
                <Link to="/OurSolutionsPage">
                  Explore Our Solutions
                  <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={imgRef} className={`lg:col-span-5 h-[60vh] lg:h-[85vh] w-full relative transition-all duration-1000 delay-300 ease-out ${imgVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            <div className="absolute inset-0 w-full h-full overflow-hidden bg-secondary/10">
              {}
              <div className="w-full h-full bg-[url('/img/modern-home-financing.jpg')] bg-cover bg-center lg:bg-fixed lg:bg-[position:75%_center] grayscale-[10%] hover:grayscale-0 transition-all duration-700" role="img" aria-label="Modern luxury home renovation showcasing professional architectural design" />
            </div>
            
            {}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 border-r-2 border-b-2 border-primary/30 hidden lg:block" />
            <div className="absolute -top-6 -left-6 w-32 h-32 border-l-2 border-t-2 border-primary/20 hidden lg:block" />
          </div>
        </div>
      </div>
    </section>;
}